// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__216ol","label":"styles_label__2hRlH"};